import React, { useContext } from "react";
import { FEATURE_FLAG_NAME } from "common/constants";
import { AuthContext } from "../Authorization/AuthContext";
import { Icon } from "../Common/Icons/LucideIcons";
import { Tooltip } from "../Common/Tooltip";
import { Body } from "../Common/Typography";
import { Container } from "./__styles__/VisibilityPill";

const MAX_CHARACTERS_TO_DISPLAY = 28;

function getUserList({ viewers = [] }: { viewers?: Array<string> }) {
  let displayedUsers: Array<string> = [];
  let remainingUsers: Array<string> = [];
  for (let i = 0; i < viewers.length; i++) {
    const user = viewers[i]!;
    const newDisplayedUsers = [...displayedUsers, user];
    if (newDisplayedUsers.join(", ").length >= MAX_CHARACTERS_TO_DISPLAY) {
      remainingUsers = viewers.slice(i);
      break;
    } else {
      displayedUsers = newDisplayedUsers;
    }
  }

  const remainingUserCount =
    remainingUsers.length > 0 ? ` +${remainingUsers.length}` : "";

  const guestsCanView = viewers.includes("guest users");

  return {
    displayedUsers: displayedUsers.join(", ") + remainingUserCount,
    remainingUsers: [
      guestsCanView ? "Guest users (form only)" : "",
      ...remainingUsers,
    ].filter(Boolean),
  };
}

export const VisibilityPill = ({ viewers }: { viewers: Array<string> }) => {
  const { admin, user, publicUser, isFeatureEnabled } = useContext(AuthContext);

  const isGuest = !admin && !user && !publicUser;
  if (isGuest || !isFeatureEnabled(FEATURE_FLAG_NAME.SUBMISSION_COMMENTS)) {
    return null;
  }

  const { displayedUsers, remainingUsers } = getUserList({
    viewers,
  });

  const content = (
    <Container>
      <Icon iconName="users" color="contentSecondary" size={16} />
      <Body type="regular" size="small" color="contentSecondary">
        Shared with {displayedUsers}
      </Body>
    </Container>
  );

  if (remainingUsers.length > 0) {
    return (
      <Tooltip
        content={content}
        popoverContent={
          <>
            {remainingUsers.map((user, index) => (
              <div key={index}>{user}</div>
            ))}
          </>
        }
        place="bottom"
        leftSpace={false}
      />
    );
  }

  return content;
};
